import { Component, OnInit } from '@angular/core';
import { LeadsService } from '../../modules/leads/services/leads.service';
import { ModalService } from '../../services/modal.service';
import { SenderService } from "../../services/sender.service";

@Component({
  selector: 'app-leads-top-bar',
  templateUrl: './leads-top-bar.component.html',
  styleUrls: ['./leads-top-bar.component.scss']
})
export class LeadsTopBarComponent implements OnInit {

  constructor(
    public senderService: SenderService,
    public modalService: ModalService,
    public leadsService: LeadsService
  ) { }

  ngOnInit(): void {
  }

  addTask() {
    this.leadsService.editLeadTask$.next();
    this.modalService.openModal('LeadsScanTasksEditModalComponent', {leadTask: false});
  }
}
